<script setup lang="ts">
//@ts-ignore
import type {PrimitiveProps} from "radix-vue";
import type {HTMLAttributes} from "vue";
import {cn} from "@/shared/lib/utils.ts";
import {Avatar, AvatarFallback, AvatarImage} from "@/shared/components/ui/avatar";
import LabelDescription from "@/shared/components/ui/labeldescription/LabelDescription.vue";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {faImage} from "@fortawesome/pro-solid-svg-icons";
import {Badge} from "@/shared/components/ui/badge";

interface Props extends PrimitiveProps {
  title: string
  description?: string
  badge?: string
  maxWidth?: number
  image?: string
  fallbackText?: string
  fallbackBgColor?: string
  showImage?: boolean
  class?: HTMLAttributes['class']
  labelClass?: HTMLAttributes['class']
  badgeClass?: HTMLAttributes['class']
  descriptionClass?: HTMLAttributes['class']
}

const props = withDefaults(defineProps<Props>(), {
  showImage: true
})
</script>

<template>
  <div :class="cn('flex items-center', badge ? '' : '', props.class)">
    <div v-if="showImage" class="relative mr-default">
      <Badge v-if="badge" :class="cn('text-xs absolute -right-1 -top-2', props.badgeClass)" variant="dark">{{ badge }}</Badge>
      <Avatar shape="square" :bg-color="fallbackBgColor? fallbackBgColor : ''">
        <AvatarImage :src="image" class="bg-white object-contain" />
        <AvatarFallback v class="text-white">
          <span v-if="fallbackText" class="text-lg">{{ fallbackText }}</span>
          <div v-else class="placeholder-image">
            <FontAwesomeIcon size="xl" color="silver" class="" :icon="faImage"/>
          </div>
        </AvatarFallback>
      </Avatar>
    </div>
    <LabelDescription :class="props.class" :label="title" :description="description" :maxWidth="maxWidth" :label-class="labelClass" :description-class="descriptionClass" />
  </div>
</template>

<style scoped>

</style>